import CommonBreadcrumb from "src/components/Breadcrumb/CssBreadcrumb";
import MergeWallet from "./MergeWallet";
import TokenComparison from "./TokenComparison";
import YourFavoriteToken from "./YourFavoriteToken";

export default function YourPortfolio() {
  return (
    <>
      <CommonBreadcrumb mb={1} config={[{ text: "scoring" }, { text: "portfolio", link: "/portfolio" }]} />
      <MergeWallet />
      <YourFavoriteToken />
      <TokenComparison />
    </>
  );
}
